import { axios, BaseApiUrl, BaseUrl } from "../axios_config";


//查询移库列表
export const getStockChangeListAsync = params => {
	return axios.post(`${BaseApiUrl}/StockChange/GetStockChangeList`, params);
           };
//查询SKU库存
export const getSKUInventory = params => {
               return axios.get(`${BaseApiUrl}/StockChange/GetSKUInventory`, { params: params });
           };
//审核移库单
export const approvedChange = params => {
    return axios.get(`${BaseApiUrl}/StockChange/ApprovedChange`, { params: params });
};
//导入
export const importData = `${BaseApiUrl}/StockChange/ImportData`;

//导出模板
export const downloadTranTemp = `${BaseUrl}/template/transfer/中转移库模板.xlsx`;
//导出模板
export const downloadTemp = `${BaseUrl}/template/transfer/集运移库模板.xlsx`;
           